(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var storageKey = 'sg-announcement-dismissed';
    var dismissButton = bar.querySelector('[data-announcement-dismiss]');

    /*
      The sticky header offsets itself by this var so it sits flush under the
      bar. Must be re-measured on resize (text can wrap to two lines on small
      screens) and zeroed when the bar is dismissed.
    */
    function syncHeight() {
      var height = bar.hidden ? 0 : bar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', height + 'px');
    }

    try {
      if (dismissButton && window.localStorage.getItem(storageKey) === 'true') {
        bar.hidden = true;
      }
    } catch (e) {
      /* localStorage unavailable (private browsing) — bar just stays visible */
    }

    syncHeight();
    window.addEventListener('resize', syncHeight, { passive: true });

    if (dismissButton) {
      dismissButton.addEventListener('click', function () {
        bar.hidden = true;
        syncHeight();
        try {
          window.localStorage.setItem(storageKey, 'true');
        } catch (e) {
          /* noop */
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    var storageKey = 'sg-email-popup-dismissed';
    var delaySeconds = parseInt(popup.dataset.delay, 10) || 8;
    var alreadyDismissed = false;

    try {
      alreadyDismissed = window.localStorage.getItem(storageKey) === 'true';
    } catch (e) {
      alreadyDismissed = false;
    }

    // Also treat a successful signup (server re-rendered the form with
    // .posted_successfully?) as "don't show again".
    var submittedSuccessfully = !!popup.querySelector('.email-popup__success');

    function dismiss() {
      popup.hidden = true;
      document.body.classList.remove('email-popup-open');
      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (e) {
        /* noop */
      }
    }

    function show() {
      if (alreadyDismissed) return;
      popup.hidden = false;
      document.body.classList.add('email-popup-open');
    }

    popup.querySelectorAll('[data-email-popup-close]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });

    if (submittedSuccessfully) {
      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (e) {
        /* noop */
      }
      show();
    } else if (!alreadyDismissed) {
      window.setTimeout(show, delaySeconds * 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* Any background variant now sticks, so the scrolled shadow applies to all. */
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    function onScroll() {
      if (window.scrollY > 20) {
        wrapper.classList.add('header-wrapper--scrolled');
      } else {
        wrapper.classList.remove('header-wrapper--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function () {
    var search = document.querySelector('[data-search]');
    if (!search) return;

    var toggle = search.querySelector('[data-search-toggle]');
    var input = search.querySelector('[data-search-input]');
    var results = search.querySelector('[data-search-results]');
    var debounceTimer;

    toggle.addEventListener('click', function () {
      var isActive = search.classList.toggle('header__search--active');
      toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');

      if (isActive) {
        input.focus();
      } else {
        input.value = '';
        results.hidden = true;
        results.innerHTML = '';
      }
    });

    document.addEventListener('click', function (event) {
      if (!search.contains(event.target)) {
        search.classList.remove('header__search--active');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && search.classList.contains('header__search--active')) {
        search.classList.remove('header__search--active');
        toggle.setAttribute('aria-expanded', 'false');
        input.value = '';
        results.hidden = true;
      }
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch(
          '/search/suggest.json?q=' +
            encodeURIComponent(query) +
            '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last'
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            renderResults(data.resources.results.products);
          })
          .catch(function () {
            results.hidden = true;
          });
      }, 300);
    });

    function renderResults(products) {
      if (!products.length) {
        results.innerHTML = '<p class="header__search-empty">' + search.dataset.noResults + '</p>';
        results.hidden = false;
        return;
      }

      results.innerHTML = products
        .map(function (product) {
          var image = product.image
            ? '<img src="' + product.image + '&width=80" alt="" class="header__search-result-image" width="40" height="40" loading="lazy">'
            : '';

          return (
            '<a href="' +
            product.url +
            '" class="header__search-result">' +
            image +
            '<span class="header__search-result-info">' +
            '<span class="header__search-result-title">' +
            product.title +
            '</span>' +
            '<span class="header__search-result-price">$' +
            product.price +
            '</span>' +
            '</span>' +
            '</a>'
          );
        })
        .join('');
      results.hidden = false;
    }
  })();

  (function () {
    var dropdowns = document.querySelectorAll('.header__nav-dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('toggle', function () {
        if (!dropdown.open) return;
        dropdowns.forEach(function (other) {
          if (other !== dropdown) other.open = false;
        });
      });
    });

    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (dropdown) {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STICK_MARGIN = 24;
    var STICK_BOTTOM = 100;

    function bindBadge(anchor) {
      if (anchor.dataset.heroBadgeBound === 'true') return;
      anchor.dataset.heroBadgeBound = 'true';

      var badge = anchor.querySelector('.hero__badge');
      if (!badge) return;

      var ticking = false;

      function update() {
        ticking = false;

        var anchorRect = anchor.getBoundingClientRect();
        var badgeHeight = badge.offsetHeight || anchorRect.height;
        var restingTop = window.innerHeight - badgeHeight - STICK_BOTTOM;

        if (anchorRect.top < restingTop) {
          var offsetRight = Math.max(STICK_MARGIN, window.innerWidth - anchorRect.right);
          badge.style.right = offsetRight + 'px';
          badge.style.bottom = STICK_BOTTOM + 'px';
          anchor.classList.add('hero__badge-anchor--stuck');
        } else {
          anchor.classList.remove('hero__badge-anchor--stuck');
          badge.style.right = '';
          badge.style.bottom = '';
        }
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      update();
    }

    function initHeroBadges(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-hero-badge-sticky]').forEach(bindBadge);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHeroBadges();
      });
    } else {
      initHeroBadges();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initHeroBadges(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-policy"]) return;
  try {
    
  (function () {
    var layout = document.querySelector('.policy-layout');
    if (!layout) return;
    var fill = layout.querySelector('.policy-progress__fill');
    if (!fill) return;

    var ticking = false;

    function update() {
      var rect = layout.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress;
      if (rect.height <= vh) {
        progress = rect.top <= 0 ? 1 : 0;
      } else {
        progress = -rect.top / (rect.height - vh);
      }
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      fill.style.height = progress * 100 + '%';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  function initPdpRelatedSwiper(root) {
    if (root.swiper) return;

    var slideCount = root.querySelectorAll('.swiper-slide').length;

    new window.Swiper(root, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      centeredSlides: true,
      initialSlide: Math.floor(slideCount / 2),
      grabCursor: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      navigation: {
        prevEl: root.parentElement.querySelector('[data-pdp-related-prev]'),
        nextEl: root.parentElement.querySelector('[data-pdp-related-next]'),
        disabledClass: 'swiper-button-disabled'
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 32 },
        1024: { slidesPerView: 3, spaceBetween: 48 }
      }
    });
  }

  function setupPdpRelated(scope) {
    if (!window.SwiperLazy) return;
    (scope || document)
      .querySelectorAll('[data-pdp-related-carousel]')
      .forEach(function (root) {
        window.SwiperLazy.mount(root, initPdpRelatedSwiper);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupPdpRelated(); });
  } else {
    setupPdpRelated();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupPdpRelated(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialsCarousel(root) {
    if (!root || root.dataset.swiperInitialized === 'true') return;

    var swiperEl = root.querySelector('.swiper');
    if (!swiperEl) return;

    var nextEl = root.querySelector('.testimonials__nav-button--next');
    var prevEl = root.querySelector('.testimonials__nav-button--prev');
    var autoplay = root.dataset.autoplay === 'true';
    var delay = parseInt(root.dataset.autoplayDelay, 10) || 5000;

    var options = {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      initialSlide: 1,
      spaceBetween: 16,
      rewind: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      breakpoints: {
        768: {
          spaceBetween: 24
        },
        1024: {
          spaceBetween: 32
        }
      }
    };

    if (autoplay) {
      options.autoplay = {
        delay: delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    root.swiperInstance = new Swiper(swiperEl, options);
    root.dataset.swiperInitialized = 'true';

    // Una sola recalculacion agrupada cuando terminan de cargar las imagenes.
    // Antes se llamaba update() por cada imagen, lo que encadenaba decenas de
    // recalculos de layout seguidos.
    var pendingUpdate = null;
    function scheduleUpdate() {
      if (pendingUpdate) return;
      pendingUpdate = setTimeout(function () {
        pendingUpdate = null;
        if (root.swiperInstance) root.swiperInstance.update();
      }, 150);
    }

    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', scheduleUpdate, { once: true });
      }
    });
  }

  function initAllTestimonialsCarousels(scope) {
    if (!window.SwiperLazy) return;
    (scope || document)
      .querySelectorAll('[data-testimonials-carousel]')
      .forEach(function (root) {
        window.SwiperLazy.mount(root, initTestimonialsCarousel);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllTestimonialsCarousels();
    });
  } else {
    initAllTestimonialsCarousels();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllTestimonialsCarousels(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-testimonials-carousel]');
    if (root && root.swiperInstance) {
      root.swiperInstance.destroy(true, true);
      delete root.swiperInstance;
      root.dataset.swiperInitialized = 'false';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
